import { getMyQnaList, patchQnaEmail, sendInquiry, updateNewAnswer } from '@/api';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { TranslationZone } from '@/styles';
import { Chat } from '@repo/components';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { ISendReceiptEmailPayload } from '@/types/common.type';
import { routes } from '@/constants/routes.const';
import { useEffect } from 'react';

const QnaPage = () => {
  const { passportNumber, nationality, email } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const dispatch = useAppDispatch();
  const LANG = nationality === 'KOR' ? 'KOR' : 'ENG';
  const history = useHistory();
  const queryClient = useQueryClient();

  const { mutate: readAnswer } = useMutation(
    () => updateNewAnswer(passportNumber || ''),
    {
      onError: (error: any) => {
        alert(error.message);
      },
    },
  );

  useEffect(() => {
    readAnswer();
  }, []);
  
  const { data: qnaList = [], refetch } = useQuery(
    ['getMyQnaList', passportNumber],
    () => getMyQnaList(passportNumber!),
  );

  const { mutate: postSendInquiry, isLoading } = useMutation(
    (payload: FormData) => sendInquiry(payload),
    {
      onSuccess: () => {
        alert(
          `You have sent an inquiry.\nPlease allow 2-3 days for a response.`,
        );
        queryClient.invalidateQueries('getMyQnaList');
      },
      onError: () => {
        alert('Failed to send the inquiry.');
      },
      retry: false,
    },
  );

  const { mutate: patchEmailMutation, isSuccess: isModifyEmailSuccess } =
    useMutation((payload: ISendReceiptEmailPayload) => patchQnaEmail(payload), {
      onSuccess: (email) => {
        dispatch({
          type: 'UPDATE_USER_INFO',
          payload: {
            email,
          },
        });
        history.push(routes.inquiryQna);
      },
      onError: (err: any) => {
        alert(err.message);
      },
    });

  const sendInquiries = (formData: FormData, onSuccess?: () => void) => {
    postSendInquiry(formData, {
      onSuccess,
    });
  };

  const moveToPage = () => {
    const endpoint = sessionStorage.getItem('inquiry-endpoint');
    history.push(endpoint || '/');
  };

  const modifyEmail = (email: string) => {
    if (!passportNumber) {
      alert(
        'Please check your passport number. If this problem persists, please try again from first step.',
      );
      return;
    }
    patchEmailMutation({ passportNumber, email });
  };

  return (
    <>
      <TranslationZone />
      <Chat
        nationality={nationality!}
        passportNumber={passportNumber!}
        email={email!}
        onClose={moveToPage}
        onSendMessage={sendInquiries}
        qnaList={qnaList}
        onGetQnaList={refetch}
        lang={LANG}
        isLoading={isLoading}
        isModifyEmailSuccess={isModifyEmailSuccess}
        onModifyEmail={modifyEmail}
      />
    </>
  );
};
export default QnaPage;
